import {
  RotateCcw,
  ChevronUp,
  Eye,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../core/redux/action";
import { useSelector, useDispatch } from "react-redux";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import {
  Button,
  message,
  Select,
  Dropdown,
  Cascader,
  InputNumber,
  Menu,
} from "antd";
import UploadReport from "./uploadreport";
import {
  useProcessedData,
  useAllReports,
  useFilterOptions,
  useBrands,
  useRefreshProcessedData
} from "../../hooks/useReportQueries";
import MailingResponseLTVSummary from "./components/MailingResponseLTVSummary";
import SalesAndCostBreakdown from "./components/SalesAndCostBreakdown";
import ResultsPerMonth from "./components/ResultsPerMonth";
import ResultsPerCampaigns from "./components/ResultsPerCampaigns";
import ResultsPerListOnly from "./components/ResultsPerListOnly";
import ResultsPerListAndCampaign from "./components/ResultsPerListAndCampaign";
import ResultsPerSegmentOfList from "./components/ResultsPerSegmentOfList";
import ResultsPerProduct from "./components/ResultsPerProduct";
import ResultsPerCategory from "./components/ResultsPerCategory";
const MailingReport = () => {
  const data = useSelector((state) => state.toggle_header);
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileToCompareWith, setSelectedFileToCompareWith] = useState(null);
  const [isUploadViewVisible, setIsUploadViewVisible] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(0);
  const selectedClients = useSelector((state) => state.selectedClients);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [isComparing, setIsComparing] = useState(false);
  const [userSelectedFilters, setUserSelectedFilters] = useState({
    client_ids: selectedClients,
    brand_ids: [],
    Year: [],
    Product: [],
    List: [],
    Segment: [],
    Category: [],
    Qtr: [],
    month: [],
    InternalExternal: [],
    Days: 60,
  });
  const [previewReportId, setPreviewReportId] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({
    client_ids: selectedClients,
    brand_ids: [],
    Year: [],
    Product: [],
    List: [],
    Segment: [],
    Category: [],
    Qtr: [],
    month: [],
    InternalExternal: [],
    Days: 60,
  });

  // React Query hooks
  const refreshProcessedData = useRefreshProcessedData();
  
  const { data: allUploadedFiles = [], isLoading: filesLoading } = useAllReports(
    { client_ids: selectedClients, brand_ids: selectedBrands },
    selectedClients.length > 0 && selectedClients[0] !== "all"
  );
  
  const { data: processedData = [], isLoading: loading, error: processedDataError } = useProcessedData(
    selectedFile,
    appliedFilters,
    isComparing && selectedFileToCompareWith ? "compare" : "process",
    selectedFileToCompareWith,
    !!selectedFile && selectedClients.length > 0
  );
  
  const { data: filterOptions = {}, isLoading: filterUpdateLoading } = useFilterOptions(
    selectedFile,
    userSelectedFilters,
    !!selectedFile
  );
  
  const { data: brands = [] } = useBrands(
    selectedClients,
    selectedClients.length > 0
  );
  
  const cascaderOptions = {
    Year: (filterOptions.Year || []).filter((item) => item != null),
    Product: (filterOptions.Product || [])
      .filter((item) => item != null)
      .map((item) => ({ value: item, label: item })),
    Campaign: (filterOptions.Campaign || [])
      .filter((item) => item != null)
      .map((item) => ({ value: item, label: item })),
    List: (filterOptions.List || [])
      .filter((item) => item != null)
      .map((item) => ({ value: item, label: item })),
    Segment: (filterOptions.Segment || [])
      .filter((item) => item != null)
      .map((item) => ({ value: item, label: item })),
    Category: (filterOptions.Category || [])
      .filter((item) => item != null)
      .map((item) => ({ value: item, label: item })),
    InternalExternal: (filterOptions.InternalExternal || [])
      .filter((item) => item != null)
      .map((item) => ({ value: item, label: item })),
  };

  const handleFilterSelection = (filterHeading, values) => {
    setUserSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterHeading]: values,
    }));
  };
  
  const applyFilters = () => {
    const newAppliedFilters = {...userSelectedFilters};
    setAppliedFilters(newAppliedFilters);
    // React Query will automatically refetch when appliedFilters changes
  };

  // Define tabItems after all required data is available
  const tabItems = [
    {
      label: "Mailing Response & LTV Summary",
      key: "1",
      children: (
        <MailingResponseLTVSummary 
          processedData={processedData}
          loading={loading}
        />
      ),
    },
    {
      label: "Sales and Cost Breakdown",
      key: "2",
      children: (
        <SalesAndCostBreakdown
          processedData={processedData}
          loading={loading}
        />
      ),
    },
    {
      label: "Results per month",
      key: "3",
      children: (
        <ResultsPerMonth
          processedData={processedData}
          loading={loading}
        />
      ),
    },
    {
      label: "Results per campaigns",
      key: "4",
      children: (
        <ResultsPerCampaigns
          processedData={processedData}
          loading={loading}
        />
      ),
    },
    {
      label: "Results per list only",
      key: "5",
      children: (
        <ResultsPerListOnly
          processedData={processedData}
          loading={loading}
        />
      ),
    },
    {
      label: "Results per list and campaign",
      key: "6",
      children: (
        <ResultsPerListAndCampaign
          processedData={processedData}
          loading={loading}
        />
      ),
    },
    {
      label: "Results per segment of list",
      key: "7",
      children: (
        <ResultsPerSegmentOfList
          processedData={processedData}
          loading={loading}
        />
      ),
    },
    {
      label: "Results per product",
      key: "8",
      children: (
        <ResultsPerProduct
          processedData={processedData}
          loading={loading}
        />
      ),
    },
    {
      label: "Results per category",
      key: "9",
      children: (
        <ResultsPerCategory
          processedData={processedData}
          loading={loading}
        />
      ),
    },
  ];

  // Now that tabItems is defined, we can declare the state
  const [activeTabKey, setActiveTabKey] = useState("1");
  const activeTabIndex = tabItems.findIndex(
    (item) => item.key === activeTabKey
  );





  // Handle errors from React Query
  useEffect(() => {
    if (processedDataError) {
      message.error("Failed to fetch data.");
      console.error("Error:", processedDataError);
    }
  }, [processedDataError]);

  // Auto-select first file when files are loaded
  useEffect(() => {
    if (allUploadedFiles.length > 0 && !selectedFile) {
      setSelectedFile(allUploadedFiles[0].value);
    } else if (allUploadedFiles.length === 0) {
      setSelectedFile(null);
    }
  }, [allUploadedFiles, selectedFile]);

  // Handle brand selection and auto-selection
  useEffect(() => {
    if (selectedClients.length === 0) {
      setSelectedBrands([]);
      return;
    }

    if (brands.length === 0) {
      setSelectedBrands([]);
      return;
    }

    const availableBrandIds = brands.map((brand) => brand.id);
    const newSelectedBrands = selectedBrands.filter((brand) =>
      availableBrandIds.includes(brand)
    );

    setSelectedBrands(newSelectedBrands);

    if (newSelectedBrands.length === 0 && brands.length === 1) {
      const autoSelectedBrand = brands[0].id;
      setSelectedBrands([autoSelectedBrand]);
      setUserSelectedFilters((prev) => ({
        ...prev,
        brand_ids: [autoSelectedBrand],
      }));
    }
  }, [selectedClients, brands]);


  // Filter options are now handled by React Query hook

  // Only fetch full data when clients/brands/file change or when apply button is clicked
 
 

  const handleFileSelection = (file) => {
    setSelectedFile(file);
    // React Query will automatically refetch when selectedFile changes
  };

  // Update filters when clients/brands change
  useEffect(() => {
    if (selectedClients.length === 0) {
      setSelectedFile(null);
      setSelectedFileToCompareWith(null);
      return;
    }

    // When clients/brands change, update both current filters and applied filters
    setUserSelectedFilters(prev => ({
      ...prev,
      client_ids: selectedClients,
      brand_ids: selectedBrands,
    }));
    setAppliedFilters(prev => ({
      ...prev,
      client_ids: selectedClients,
      brand_ids: selectedBrands,
    }));
  }, [selectedClients, selectedBrands]);

 
    
 
 
  return (
    <div className="">
      <div className="" style={{
          width: isUploadViewVisible
            ? `calc(100% - ${sidebarWidth}px)`
            : "100%",
          transition: "width 0.3s ease-in-out",
        }}
      >
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Mailing Response Report</h4>
            </div>
          </div>

          <ul className="table-top-head">
            <div
              hidden={
                selectedClients.length !== 1 || selectedClients[0] === "all"
              }
            >
              <Select
                style={{ width: 400 }}
                className="me-2"
                placeholder="Select from Existing files to Process"
                value={selectedFile}
                onChange={(v) => handleFileSelection(v)}
              >
                {allUploadedFiles.map((file) => (
                  <Select.Option key={file.value} value={file.value}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>{file.label}</span>
                      <Button
                        type="info"
                        className="mt-1"
                        icon={<Eye size={18} className="feather-view" />}
                        onClick={(e) => {
                          e.stopPropagation();
                          setPreviewReportId(file.value);
                          setIsUploadViewVisible(true);
                        }}
                      />
                    </div>
                  </Select.Option>
                ))}
              </Select>
              <Button
                className="me-2"
                onClick={() => {
                  setIsComparing(!isComparing);
                  setSelectedFileToCompareWith(null);
                }}
              >
                {isComparing ? "Stop Comparing" : "Compare with"}
              </Button>
              <Select
                hidden={!isComparing}
                style={{ width: 400 }}
                className="me-2"
                placeholder="Select file to compare with"
                allowClear
                value={selectedFileToCompareWith}
                onChange={(v) => {
                  if (v !== selectedFile) {
                    setSelectedFileToCompareWith(v);
                  } else {
                    setSelectedFileToCompareWith(null);
                    message.warning("Please select a different file.");
                  }
                }}
              >
                {allUploadedFiles.map((file) => (
                  <Select.Option key={file.value} value={file.value}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>{file.label}</span>
                      <Button
                        type="info"
                        className="mt-1"
                        icon={<Eye size={18} className="feather-view" />}
                        onClick={(e) => {
                          e.stopPropagation();
                          setPreviewReportId(file.value);
                          setIsUploadViewVisible(true);
                        }}
                      />
                    </div>
                  </Select.Option>
                ))}
              </Select>
              <Button
                className="me-2"
                hidden={!(isComparing && selectedFileToCompareWith)}
                onClick={() => {
                  // Trigger manual refetch for comparison
                  refreshProcessedData(
                    selectedFile,
                    appliedFilters,
                    "compare",
                    selectedFileToCompareWith
                  );
                }}
              >
                {"Go"}
              </Button>
            </div>
        
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="excel-tooltip">Excel</Tooltip>}
              >
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath src="assets/img/icons/xls.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
      
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="refresh-tooltip">Refresh</Tooltip>}
              >
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={() =>
                    refreshProcessedData(selectedFile, appliedFilters, "process", null)
                  }
                >
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="collapse-tooltip">Collapse</Tooltip>}
              >
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        <div className="d-flex">
          <div
            className="d-flex flex-column h-100 position-sticky top-0 me-2"
            style={{ width: "15%" }}
          >
            <div className="mb-3" id="brand-select">
              <span>Brand </span> <br />
              <Cascader
                options={brands.map((brand) => ({
                  value: brand.id,
                  label: brand.brand_name,
                }))}
                placeholder="All"
                multiple
                showSearch
                allowClear
                value={selectedBrands}
                onChange={(values) => {
                  setSelectedBrands(values);
                  setUserSelectedFilters((prev) => ({
                    ...prev,
                    brand_ids: values,
                  }));
                }}
              />
            </div>
            {Object.keys(cascaderOptions)?.map((filterHeading, index) => (
              <div key={index} className="mb-3">
                <span> {filterHeading}</span> <br />
                <Cascader
                  options={cascaderOptions[filterHeading] || []}
                  placeholder={`All`}
                  multiple
                  allowClear
                  showSearch
                  value={userSelectedFilters[filterHeading] || []}
                  onChange={(values) =>
                    handleFilterSelection(filterHeading, values)
                  }
                  loading={filterUpdateLoading}
                />
              </div>
            ))}
            <div className="mb-3">
              <span>Min Days Since Mailing</span>
              <br />
              <InputNumber
                min={0}
                value={userSelectedFilters.Days}
                onChange={(value) => {
                  setUserSelectedFilters((prev) => ({
                    ...prev,
                    Days: value ?? 0,
                  }));
                }}
                style={{ width: "70%" }}
              />
            </div>
            <div className="mb-3">
              <Button 
                type="primary" 
                onClick={applyFilters} 
                style={{ width: "100%" }}
                loading={loading}
              >
                Apply Filters
              </Button>
            </div>
          </div>

          <div style={{ width: "100%", borderRadius: "5px" }}>
 
            
            {/* Tab Navigation with Dropdown */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
                padding: "10px",
                backgroundColor: "#f5f5f5",
                borderRadius: "5px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* Current Tab Display */}
                <h4 style={{ margin: 0, marginRight: "15px" }}>
                  {tabItems.find((item) => item.key === activeTabKey)?.label}
                </h4>

                {/* Dropdown for Tab Selection */}
                <Dropdown
                  overlay={
                    <Menu onClick={({ key }) => setActiveTabKey(key)}>
                      {tabItems.map((item) => (
                        <Menu.Item key={item.key}>{item.label}</Menu.Item>
                      ))}
                    </Menu>
                  }
                  trigger={["click"]}
                >
                  <Button>
                    Change View{" "}
                    <i
                      className="fas fa-chevron-down"
                      style={{ marginLeft: "5px" }}
                    ></i>
                  </Button>
                </Dropdown>
              </div>

              {/* Navigation Buttons */}
              <div>
                <Button
                  disabled={activeTabIndex <= 0}
                  onClick={() =>
                    setActiveTabKey(tabItems[activeTabIndex - 1]?.key)
                  }
                  style={{ marginRight: "5px" }}
                >
                  Previous
                </Button>
                <Button
                  disabled={activeTabIndex >= tabItems.length - 1}
                  onClick={() =>
                    setActiveTabKey(tabItems[activeTabIndex + 1]?.key)
                  }
                  type="primary"
                >
                  Next
                </Button>
              </div>
            </div>

            {/* Tab Content */}
            <div
              style={{
                padding: "15px",
                border: "1px solid #f0f0f0",
                borderRadius: "5px",
              }}
            >
              {tabItems.find((item) => item.key === activeTabKey)?.children}
            </div>
          </div>
        </div>
      </div>
      <UploadReport
        isVisible={isUploadViewVisible}
        onClose={() => {
          setIsUploadViewVisible(false);
          setPreviewReportId(null);
        }}
        onResize={setSidebarWidth}
        fetchFiles={() => { /* Files are now handled by React Query */ }}
        clientId={selectedClients[0]}
        reportId={previewReportId}
      />
    </div>
  );
};

export default MailingReport;
